const defaultConfig = {
  footer: {
    permitUrl: "https://sasw.mohw.gov.tw/app39/solicitView/index",
    permitNo: "衛部救字第1151360925號",
  },
  donateReports: [
    {
      year: "108年",
      period: "107年09月01日~108年08月31日",
      file: "108.pdf",
    },
    {
      year: "109年",
      period: "108年09月16日~109年08月31日",
      file: "109.pdf",
    },
    {
      year: "110年",
      period: "110年05月14日~110年08月31日",
      file: "110.pdf",
    },
    {
      year: "111年",
      period: "110年12月03日~111年08月31日",
      file: "111.pdf",
    },
    {
      year: "112年",
      period: "112年03月15日~112年12月31日",
      file: "112.pdf",
    },
    {
      year: "113年",
      period: "113年01月01日~113年12月31日",
      file: "113.pdf",
    },
    {
      year: "114年",
      period: "114年01月01日~114年12月31日",
      file: "114.pdf",
    },
  ],
};

function sanitizeFooterConfig(footerConfig) {
  return {
    permitUrl: footerConfig?.permitUrl || defaultConfig.footer.permitUrl,
    permitNo: footerConfig?.permitNo || defaultConfig.footer.permitNo,
  };
}

function sanitizeDonateReports(donateReports) {
  if (!Array.isArray(donateReports) || donateReports.length === 0) {
    return defaultConfig.donateReports;
  }

  const sanitizedReports = donateReports
    .map((report) => ({
      year: report?.year || "",
      period: report?.period || "",
      file: report?.file || "",
    }))
    .filter((report) => report.year && report.period && report.file);

  return sanitizedReports.length > 0 ? sanitizedReports : defaultConfig.donateReports;
}

function getRuntimeConfig() {
  if (typeof window === "undefined" || typeof window.CRAZYCAT_CONFIG !== "object") {
    return defaultConfig;
  }

  return {
    footer: sanitizeFooterConfig(window.CRAZYCAT_CONFIG.footer),
    donateReports: sanitizeDonateReports(window.CRAZYCAT_CONFIG.donateReports),
  };
}

export function getFooterConfig() {
  return getRuntimeConfig().footer;
}

export function getDonateReports() {
  return getRuntimeConfig().donateReports;
}

export default defaultConfig;
